import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/depensespro`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    Authorization: `Bearer ${token}`,
  };
};

export const getAllDepensesPro = async () => {
  const response = await axios.get(`${apiUrl}/alldepensespro`, {
    headers: getAuthHeaders(),
  });

  return response.data;
};

export const getDepenseProById = async (depenseProId) => {
  const response = await axios.get(
    `${apiUrl}/depenseproById/${depenseProId}`,
    {
      headers: getAuthHeaders(),
    }
  );

  return response.data;
};

export const getDepensesProByCategorie = async () => {
  const response = await axios.get(`${apiUrl}/depensesproByCategorie`, {
    headers: getAuthHeaders(),
  });

  return response.data;
};

export const addDepensePro = async (depensePro) => {
  const response = await axios.post(`${apiUrl}/addDepensePro`, depensePro, {
    headers: getAuthHeaders(),
  });

  return response.data;
};

export const updateDepensePro = async (id, depenseProData) => {
  const response = await axios.patch(
    `${apiUrl}/updateDepensePro/${id}`,
    depenseProData,
    {
      headers: getAuthHeaders(),
    }
  );

  return response.data;
};

export const deleteDepensePro = async (depenseProId) => {
  const response = await axios.delete(
    `${apiUrl}/deleteDepensePro/${depenseProId}`,
    {
      headers: getAuthHeaders(),
    }
  );

  return response.data;
};